import React from 'react';
import "./style.scss";

export default function MyBadges({variant= "default", children, nowrap}){
  let className = "my-badges my-badges"+(variant?("-"+variant):"")
  if(nowrap) className += " my-badges-nowrap"
  return <label className={className}>{children}</label>
}